import { useContext } from 'react';
import { ImageManagerContext } from '@/context/ImageManagerProvider';

export const useImageManager = () => {
  const context = useContext(ImageManagerContext);
  if (!context) {
    throw new Error('useImageManager must be used within ImageManagerProvider');
  }
  return context;
};
